var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCartPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 140,
    viewBox: "0 0 257 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9255 72.9492H26.7327C26.4446 72.9492 26.1683 73.0637 25.9646 73.2674C25.7609 73.4711 25.6465 73.7473 25.6465 74.0354V77.6315C25.6465 77.9196 25.7609 78.1959 25.9646 78.3996C26.1683 78.6033 26.4446 78.7177 26.7327 78.7177H28.0904V84.1058H33.5678V78.7177H34.9255C35.2136 78.7177 35.4899 78.6033 35.6936 78.3996C35.8973 78.1959 36.0117 77.9196 36.0117 77.6315V74.0354C36.0117 73.7473 35.8973 73.4711 35.6936 73.2674C35.4899 73.0637 35.2136 72.9492 34.9255 72.9492Z",
    fill: "#FFE8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1304 105.86C38.1129 98.5184 35.5478 89.7767 35.8027 80.8876C35.8072 80.6825 35.7407 80.4821 35.6143 80.3205C35.4879 80.1589 35.3094 80.0461 35.1093 80.0011V78.4473H26.4566V79.9795H26.3373C26.2153 79.9797 26.0946 80.005 25.9828 80.0539C25.871 80.1028 25.7704 80.1742 25.6875 80.2637C25.6045 80.3532 25.5409 80.4588 25.5005 80.574C25.4602 80.6892 25.4441 80.8114 25.4531 80.9331C26.1348 90.4355 23.8329 98.957 18.5476 106.498C18.2434 106.931 18.088 107.451 18.1047 107.98L19.0509 137.247C19.0736 137.9 19.3476 138.519 19.8156 138.974C20.2836 139.43 20.9096 139.687 21.5627 139.692H41.1338C41.7944 139.687 42.4269 139.424 42.8963 138.959C43.3658 138.494 43.6352 137.864 43.6472 137.204L44.0118 108.788C44.0226 107.746 43.7151 106.724 43.1304 105.86Z",
    fill: "#EA3B3B",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.2181 74.1211C33.2181 74.7426 32.9712 75.3387 32.5318 75.7782C32.0923 76.2176 31.4962 76.4645 30.8747 76.4645C30.2532 76.4645 29.6571 76.2176 29.2176 75.7782C28.7781 75.3387 28.5312 74.7426 28.5312 74.1211",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0321 115.583H37.6622C37.436 114.115 36.6917 112.776 35.5642 111.809C34.4366 110.842 33.0002 110.311 31.5146 110.311C30.0291 110.311 28.5927 110.842 27.4651 111.809C26.3376 112.776 25.5933 114.115 25.3671 115.583H22.997C22.7448 115.583 22.4957 115.638 22.2665 115.743C22.0374 115.848 21.8338 116.002 21.6696 116.193C21.5054 116.385 21.3846 116.609 21.3153 116.852C21.246 117.094 21.23 117.349 21.2684 117.598L23.8426 134.331H38.6243L41.7511 117.655C41.7985 117.402 41.7896 117.142 41.7251 116.893C41.6606 116.645 41.5421 116.413 41.378 116.215C41.2139 116.018 41.0082 115.858 40.7756 115.749C40.543 115.64 40.2891 115.583 40.0321 115.583Z",
    fill: "#FFE8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.188 88.6875L238.62 111.409L237.916 139.584H213.952L213.127 106.573L212.68 88.6875H239.188Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.526 76.5996H224.133V121.558H227.526V76.5996Z",
    fill: "#FFE8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.472 135.908L236.827 138.091H214.877L214.121 135.534C216.099 135.496 218.17 135.487 220.205 135.505C222.24 135.524 224.195 135.571 225.949 135.643C229.617 135.789 233.737 135.867 237.472 135.908Z",
    fill: "#EA3B3B",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.414 109.443H217.301V112.557H220.414V109.443Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.535 103.08H219.422V106.194H222.535V103.08Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.221 107.486L226.721 105.631L224.866 108.132L227.367 109.986L229.221 107.486Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.846 113.001L232.346 111.146L230.491 113.647L232.992 115.502L234.846 113.001Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.304 116.183L222.803 114.328L220.948 116.829L223.449 118.684L225.304 116.183Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.615 101.835C232.966 101.835 233.251 101.55 233.251 101.199C233.251 100.847 232.966 100.562 232.615 100.562C232.263 100.562 231.979 100.847 231.979 101.199C231.979 101.55 232.263 101.835 232.615 101.835Z",
    fill: "#EA3B3B",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.679 97.5947C220.031 97.5947 220.315 97.3098 220.315 96.9585C220.315 96.6071 220.031 96.3223 219.679 96.3223C219.328 96.3223 219.043 96.6071 219.043 96.9585C219.043 97.3098 219.328 97.5947 219.679 97.5947Z",
    fill: "#EA3B3B",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.494 93.1415C230.845 93.1415 231.13 92.8567 231.13 92.5053C231.13 92.154 230.845 91.8691 230.494 91.8691C230.142 91.8691 229.857 92.154 229.857 92.5053C229.857 92.8567 230.142 93.1415 230.494 93.1415Z",
    fill: "#EA3B3B",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.646 139.39C167.137 139.39 198.341 108.186 198.341 69.6948C198.341 31.2034 167.137 0 128.646 0C90.1546 0 58.9512 31.2034 58.9512 69.6948C58.9512 108.186 90.1546 139.39 128.646 139.39Z",
    fill: "#FFE8E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.647 120.565C116.878 120.565 105.473 116.484 96.3757 109.017C87.2781 101.551 81.0508 91.1614 78.7548 79.6184C76.4589 68.0755 78.2363 56.0936 83.7842 45.7142C89.3322 35.3348 98.3074 27.2002 109.181 22.6964C120.054 18.1926 132.152 17.5983 143.415 21.0147C154.677 24.4311 164.406 31.6469 170.945 41.4325C177.483 51.2182 180.426 62.9682 179.273 74.6806C178.119 86.393 172.94 97.3431 164.618 105.665C159.905 110.404 154.3 114.16 148.125 116.718C141.951 119.275 135.33 120.583 128.647 120.565ZM128.647 21.961C102.327 21.961 80.9141 43.3739 80.9141 69.6941C80.9141 96.0141 102.327 117.427 128.647 117.427C154.967 117.427 176.38 96.0141 176.38 69.6941C176.38 43.3739 154.967 21.961 128.647 21.961Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.646 118.996C155.874 118.996 177.947 96.923 177.947 69.6944C177.947 42.4658 155.874 20.3926 128.646 20.3926C101.417 20.3926 79.3438 42.4658 79.3438 69.6944C79.3438 96.923 101.417 118.996 128.646 118.996Z",
    fill: "#EA3B3B",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 139.314H0.5V139.96H256.5V139.314Z",
    fill: "#EA3B3B",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCartPlate);
export default __webpack_public_path__ + "static/media/emptyCartPlate.c6207a232bf491d607c55bc5bcb850b2.svg";
export { ForwardRef as ReactComponent };